import { User } from 'features/user'
import { Can } from 'providers/casl'
import { onEditor } from './onEditor'
import { onFinancialViewer } from './onFinancialViewer'
import { onOwner } from './onOwner'
import { onViewer } from './onViewer'

export const userByWorkspaceRole = (user: User, can: Can) => {
  switch (user.currentWorkspaceRole) {
    case 'editor': {
      onEditor(can)
      break
    }
    case 'financialViewer': {
      onFinancialViewer(can)
      break
    }
    case 'owner': {
      onOwner(can)
      break
    }
    case 'viewer': {
      onViewer(can)
      break
    }
  }
}
